import {ITemplate} from 'interfaces';
// Not using index import for services to avoid circular dependency
import {axiosAPI} from './API';

interface ICreateTemplateResponse {
    id: number,
}

// Singleton for interacting with templates
class _TemplatesService {

    public allTemplates: ITemplate[] = [];
    public allTemplatesMap: {[id: number]: ITemplate} = {};

    public getAllTemplates = (): Promise<ITemplate[]> => {
        const p = axiosAPI.get<ITemplate[]>('/templates')
            .then((resp) => {
                let templates = resp.data;
                templates.forEach((t) => this.allTemplatesMap[t.id] = t);
                this.allTemplates = templates.filter(t => !t.isDeleted);
                this.sortAllTemplates();
                return templates;
            });
        
        p.catch((err) => {
            console.error('Error getting all templates: ', err);
        });

        return p;
    }

    public createTemplateFromUpdate = (template: ITemplate): Promise<ICreateTemplateResponse> => {
        const p = axiosAPI.post<ICreateTemplateResponse>('/templates', template)
            .then((resp) => {
                template.id = resp.data.id;
                this.allTemplates.push(template);
                this.sortAllTemplates();
                this.allTemplatesMap[template.id] = template;
                return resp.data;
            });
        
        p.catch((err) => {
            console.error('Error creating template: ', err);
        });

        return p;
    }

    public deleteTemplate = (id: number): Promise<any> => {
        const p = axiosAPI.delete<any>(`/templates/${id}`)
            .then((resp) => {
                this.allTemplates = this.allTemplates.filter(t => t.id != id);
                this.allTemplatesMap[id].isDeleted = true;
                return;
            });
        
        p.catch((err) => {
            console.error('Error deleting template: ', err);
        });

        return p;
    }

    sortAllTemplates() {
        const collator = new Intl.Collator(undefined, {numeric: true, sensitivity: 'base'});
        this.allTemplates = this.allTemplates.sort((a, b) => collator.compare(a.name, b.name));
    }
}

export const TemplatesService = new _TemplatesService();